import { returnsTeamWeightByZoneSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const saveTeamOverrideRateTable = {
  name: "saveTeamOverrideRateTable" as const,
  input: z.object({
    teamId: zExt.objectId(),
    rateTable: returnsTeamWeightByZoneSchema,
  }),
  output: z.object({ rateTables: z.array(returnsTeamWeightByZoneSchema) }),
};
